import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import formValidation from "../../validations/es6/core/Core";
import {
  Card,
  Row,
  CardBody,
  Col,
  FormGroup,
  Label,
  Badge,
  FormText,
  Button,
  CustomInput,
  Alert,
  Form,
  Input
} from "reactstrap";
import axios from "axios";
import { useFetch } from "../../utils/fetchHook";
import { getCookie } from "../../jwt/_helpers/cookie";
import { optUpdate } from "./labelsValidation";
import { updateLabel } from "../../redux/labels/action";
import { labelImageUpload } from "../../utils/labelDemoHelpers";
import {
  getDemoTrackBlob,
  isWlDemoBlobRef,
  wlDemoBlobStorageKeyFromRef,
} from "../../utils/demoTrackBlobStore";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const LabelsUpdate = ({ match, name }) => {
  const dispatch = useDispatch();
  const stateRef = useRef();
  const stateRefPromo = useRef();
  const fvRef = useRef();
  const existingLogoRef = useRef(null);
  const existingPromoRef = useRef(null);
  const hasExistingLogoRef = useRef(false);

  const currentID = match.url.split("/")[2];
  const token = getCookie("token");
  const [initFormData] = useFetch("GET", `labels/${currentID}/`, token);


  //ajax handlers
  const [success, setSuccess] = useState(false);
  const [errorPut, setError] = useState(false);

  const [logoSelected, setLogo] = useState(null);
  const [promoGraphicSelected, setPromo] = useState(null);

  const [logoPreview, setLogoPreview] = useState(null);
  const [logoImgUrl, setLogoImgUrl] = useState(null);
  const [promoPreview, setPromoPreview] = useState(null);
  const [promoImgUrl, setPromoImgUrl] = useState(null);

  const [redirect, setRedirect] = useState(false);

  stateRef.current = logoSelected;
  stateRefPromo.current = promoGraphicSelected;

  const clearValidationErrors = (formName, validatorName) => {
    let formID = document.getElementById(formName);
    if(formID) {
      const messages = [].slice.call(formID.querySelectorAll('[data-field="' + validatorName + '"][data-validator]'));
      messages.forEach((messageEle) => {
        messageEle.style.display = 'none';
      });
    }
  }

  const revalidateField = (name) => {
    if(fvRef.current) {
      let fv = fvRef.current;
      clearValidationErrors("addNewLabel", name);
      fv.revalidateField(name);
    }
  }

  const resolveLabelImagePreview = async (raw) => {
    if (!raw) {
      return null;
    }
    if (isWlDemoBlobRef(raw)) {
      const storageKey = wlDemoBlobStorageKeyFromRef(raw);
      const blob = await getDemoTrackBlob(storageKey);
      return blob ? URL.createObjectURL(blob) : null;
    }
    return raw;
  };

  const getLabelImageRaw = (imageField) => {
    if (!imageField) {
      return null;
    }
    if (typeof imageField === "string") {
      return imageField;
    }
    return imageField.full_size || imageField.thumb_small || null;
  };

  useEffect(() => {
    var formID = document.getElementById("addNewLabel");
    let fv = formValidation(formID, optUpdate)
    fvRef.current = fv;

    fv.on("core.element.validated", function(e) {
      if (e.valid) {
          const messages = [].slice.call(formID.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
          messages.forEach((messageEle) => {
              messageEle.style.display = 'none';
          });
          return;
        }
      }
    )
    .on("core.validator.validated", function(e) {
      if (!e.result.valid) {
        const messages = [].slice.call(formID.querySelectorAll('[data-field="' + e.field + '"][data-validator]'));
        for(let i = 0; i < messages.length - 1; i++) {
          const messageEle = messages[i];
          messageEle.style.display = 'none';
        }
      }
    })
    .on("core.form.valid", async e => {
      const hasExistingLogo = hasExistingLogoRef.current;
      const hasNewLogo = Boolean(stateRef.current);
      if (!hasNewLogo && !hasExistingLogo) {
        return;
      }

      let patchData = {};

      const getData = inputName => formID.querySelector(`[name="${inputName}"]`).value;

      const checkData = (name, newVal) => (name !== newVal ? true : false);

      if (stateRef.current) {
        patchData.logo = stateRef.current;
      }

      if (stateRefPromo.current) {
        patchData.promo_graphic = stateRefPromo.current;
      }

      if (checkData(initFormData.primary_genre, getData("genre"))) {
        patchData.primary_genre = getData("genre");
      }
      if (checkData(initFormData.secondary_genre, getData("secondaryGenre"))) {
        patchData.secondary_genre = getData("secondaryGenre");
      }
      if (checkData(initFormData.year, getData("year"))) {
        patchData.year = getData("year");
      }
      if (checkData(initFormData.catalog_num, getData("releaseCatalog"))) {
        patchData.catalog_num = getData("releaseCatalog");
      }
      if (checkData(initFormData.soundcloud, getData("soundcloud"))) {
        patchData.soundcloud = getData("soundcloud");
      }
      if (checkData(initFormData.website, getData("website"))) {
        patchData.website = getData("website");
      }
      if (checkData(initFormData.facebook, getData("facebook"))) {
        patchData.facebook = getData("facebook");
      }
      if (checkData(initFormData.twitter, getData("twitter"))) {
        patchData.twitter = getData("twitter");
      }
      if (checkData(initFormData.youtube, getData("youtube"))) {
        patchData.youtube = getData("youtube");
      }
      if (checkData(initFormData.instagram, getData("instagram"))) {
        patchData.instagram = getData("instagram");
      }
      if (checkData(initFormData.mixcloud, getData("mixcloud"))) {
        patchData.mixcloud = getData("mixcloud");
      }
      if (checkData(initFormData.beatport, getData("beatport"))) {
        patchData.beatport = getData("beatport");
      }

      axios({
        method: "PATCH",
        mode: 'cors',
        url: `${API_URL}labels/${currentID}/`,
        data: patchData,
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": X_API_KEY,
          "Content-Type": "application/json",
        }
      }).then(function(response) {
        if (response.status === 200) {
          if (response.data) {
            dispatch(updateLabel(response.data));
          }
          setSuccess(true);
          setTimeout(() => setRedirect(true), 1000);
        } else {
          setError(true);
        }
      });
    });
  }, [dispatch, initFormData, token]);


  useEffect(() => {
    let cancelled = false;
    let objectUrl = null;

    const syncLogoPreview = async () => {
      if (logoPreview) {
        objectUrl = URL.createObjectURL(logoPreview);
        setLogoImgUrl(objectUrl);
        return;
      }

      const raw = getLabelImageRaw(initFormData.logo);
      existingLogoRef.current = raw;
      hasExistingLogoRef.current = Boolean(raw);

      if (!raw) {
        setLogoImgUrl(null);
        return;
      }

      const url = await resolveLabelImagePreview(raw);
      if (!cancelled) {
        setLogoImgUrl(url);
        if (url && url.startsWith("blob:")) {
          objectUrl = url;
        }
      }
    };

    syncLogoPreview();

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [initFormData, logoPreview]);

  useEffect(() => {
    let cancelled = false;
    let objectUrl = null;

    const syncPromoPreview = async () => {
      if (promoPreview) {
        objectUrl = URL.createObjectURL(promoPreview);
        setPromoImgUrl(objectUrl);
        return;
      }

      const raw = getLabelImageRaw(initFormData.promo_graphic);
      existingPromoRef.current = raw;

      if (!raw) {
        setPromoImgUrl(null);
        return;
      }

      const url = await resolveLabelImagePreview(raw);
      if (!cancelled) {
        setPromoImgUrl(url);
        if (url && url.startsWith("blob:")) {
          objectUrl = url;
        }
      }
    };

    syncPromoPreview();

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [initFormData, promoPreview]);

  const handleLabelImage = async (file, kind) => {
    if (!file) {
      return null;
    }
    const ref = await labelImageUpload(file, kind);
    if (!ref) {
      return null;
    }
    if (kind === 'logo') {
      setLogo(ref);
    } else {
      setPromo(ref);
    }
    return ref;
  };

  const handleLogoChange = async (e) => {
    const file = e.target.files?.[0] || null;
    setLogoPreview(file);
    if (!file) {
      setLogo(null);
      return;
    }
    if (fvRef.current) {
      const status = await fvRef.current.validateField("logo");
      if (status === "Valid") {
        await handleLabelImage(file, "logo");
      }
    }
  };

  const handlePromoChange = async (e) => {
    const file = e.target.files?.[0] || null;
    setPromoPreview(file);
    if (!file) {
      setPromo(null);
      return;
    }
    if (fvRef.current) {
      const status = await fvRef.current.validateField("promo_graphic");
      if (status === "Valid") {
        await handleLabelImage(file, "promo_graphic");
      }
    }
  };

  return (
    <div>
      <Row>
        <Col sm={12}>
          <Card>
            <CardBody>
              <h3>Edit label</h3>
              <Form id="addNewLabel">
                <FormGroup>
                  <Label for="name">Name</Label> <Badge color="primary">Required</Badge>
                  <Input
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.name}
                    disabled={true}
                  />
                </FormGroup>
                {/* <FormGroup>
                  <Label>Label biography</Label>
                  <Input
                    name="labelBio"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.biography}
                  />
                </FormGroup> */}
                <FormGroup>
                  <Label for="image">Logo</Label> <Badge color="primary">Required</Badge>
                  <CustomInput
                    type="file"
                    id="logo"
                    name="logo"
                    accept=".jpeg,.jpg,.png"
                    onChange={handleLogoChange}
                    onFocus={() => {
                      revalidateField("logo");
                    }}
                  />
                  <FormText color="muted">
                    Upload JPG or PNG formats, resolution only 1000x1000 px
                  </FormText>
                  {logoImgUrl && (
                    <img
                      alt="Your Logo"
                      src={logoImgUrl? logoImgUrl: ""}
                      style={{
                        width: "auto",
                        maxWidth: "100%",
                        maxHeight: 200
                      }}
                    />
                  )}
                </FormGroup>
                <FormGroup>
                  <Label for="image">Promotional Graphic</Label>
                  <CustomInput
                    type="file"
                    id="promoGraphic"
                    name="promo_graphic"
                    accept=".jpeg,.jpg,.png"
                    onChange={handlePromoChange}
                    onFocus={() => {
                      revalidateField("promo_graphic");
                    }}
                  />
                  <FormText color="muted">
                    Upload JPG or PNG formats, resolution only 960x150px, max 100kb
                  </FormText>
                  {promoImgUrl && (
                    <img
                      alt="Your promotional graphic"
                      src={promoImgUrl? promoImgUrl: ""}
                      style={{
                        width: "auto",
                        maxWidth: "100%",
                        maxHeight: 200
                      }}
                    />
                  )}
                </FormGroup>
                <FormGroup>
                  <Label>Primary genre</Label>
                  <Input
                    name="genre"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.primary_genre}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Secondary genre</Label>
                  <Input
                    name="secondaryGenre"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.secondary_genre}
                  />
                </FormGroup>
                <FormGroup>
                <Label for="year">Year established</Label> <Badge color="primary">Required</Badge>
                  <Input
                    name="year"
                    type="text"
                    className="form-control"
                    onFocus={() => {
                      revalidateField("year");
                    }}
                    defaultValue={initFormData.year}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="releaseCatalog">Releases in catalog</Label> <Badge color="primary">Required</Badge>
                  <Input
                    name="releaseCatalog"
                    type="text"
                    className="form-control"
                    onFocus={() => {
                      revalidateField("releaseCatalog");
                    }}
                    defaultValue={initFormData.catalog_num}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Soundcloud</Label>
                  <Input
                    name="soundcloud"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.soundcloud}
                  />
                </FormGroup>
                {/* <FormGroup>
                  <Label>Skype</Label>
                  <Input
                    name="skype"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.skype}
                  />
                </FormGroup> */}
                <FormGroup>
                  <Label>Website</Label>
                  <Input
                    name="website"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.website}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Facebook</Label>
                  <Input
                    name="facebook"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.facebook}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Twitter</Label>
                  <Input
                    name="twitter"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.twitter}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Youtube</Label>
                  <Input
                    name="youtube"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.youtube}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Instagram</Label>
                  <Input
                    name="instagram"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.instagram}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Mixcloud</Label>
                  <Input
                    name="mixcloud"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.mixcloud}
                  />
                </FormGroup>
                {/* <FormGroup>
                  <Label>Myspace</Label>
                  <Input
                    name="myspace"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.myspace}
                  />
                </FormGroup> */}
                <FormGroup>
                  <Label>Beatport</Label>
                  <Input
                    name="beatport"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.beatport}
                  />
                </FormGroup>
                {/* <FormGroup>
                  <Label>Itunes</Label>
                  <Input
                    name="itunes"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.itunes}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Junodownload</Label>
                  <Input
                    name="junodownload"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.junodownload}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Googlemusic</Label>
                  <Input
                    name="googlemusic"
                    type="text"
                    className="form-control"
                    defaultValue={initFormData.googlemusic}
                  />
                </FormGroup> */}

                <Button color="success" type="submit">
                  Submit
                </Button>
              </Form>

              <div style={{ paddingTop: "24px" }}>
                {success && (
                  <Alert color="success">Label has been updated!</Alert>
                )}
                {redirect ? <Redirect to="/labels" /> : null}
                {errorPut && (
                  <Alert color="danger">
                    Something went wrong! Please refresh page and try again!
                  </Alert>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default LabelsUpdate;
